import { Box } from '@material-ui/core';
import { StandardDialog, Button, } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useInterestAllocationStore } from '@roc/feature-payoffs';
import { InterestAllocationTable } from './interestAllocationTable';
import { useDocumentStore } from '@roc/feature-documents';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface IInterestAllocationModalProps {
  loanId: number;
  open: boolean;
  onClose: () => void;
  document: Document;
}

const columns: any[] = [
  {
    name: 'Description',
    width: '10%',
    align: 'left',
    mapping: 'description',
  },
  {
    name: 'Total Interest',
    width: '18%',
    align: 'center',
    mapping: 'totalInterest',
  },
  {
    name: 'Loan Servicer (LS)',
    width: '18%',
    align: 'center',
    mapping: 'loanServicer',
  },
  {
    name: 'Tpo',
    width: '18%',
    align: 'center',
    mapping: 'tpo',
  },
  {
    name: 'Investor',
    width: '18%',
    align: 'center',
    mapping: 'investor',
  },
  {
    name: 'Funder',
    width: '18%',
    align: 'center',
    mapping: 'funder',
  },
];

const useStyles = makeStyles(theme => ({
  entityLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  autoComplete: {
    minWidth: '400px'
  },

  editableInput: {
    backgroundColor: 'transparent',
    border: 'solid lightgrey 1px',
    outline: 'none',
    marginBottom: 0,
    width: '100%',
    borderRadius: 8,
    fontFamily: 'Oswald, sans-serif;',
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginRight: '8px'
  },
}));

export const InterestAllocationModal = observer(({ loanId, open, onClose, document }: IInterestAllocationModalProps) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { interestAllocationStore },
    },
  } = useDocumentStore();
  const taskId = document?.taskId;

  useEffect(() => {
    if (open) {
      interestAllocationStore.getDefaultInterestAllocation(loanId);
    }
  }, [open])

  const saveAction = async () => {
    await interestAllocationStore.saveDefaultInterestAllocation(loanId);
    interestAllocationStore.getDefaultInterestAllocation(loanId);
  }

  const getContent = () => {
    return (
      <Box display="flex" flexDirection="column" height="100%" width="100%">
        <InterestAllocationTable columns={columns} rows={interestAllocationStore?.interestAllocatioDataRows} />
      </Box>
    )
  }

  const dialogActions = (
    <>
      <Box mr={2}>
        <Button
          className={classes.button}
          variant="outlined"
          color="primary"
          onClick={onClose}
          testId="cancel"
        >
          CANCEL
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={saveAction}
          testId="save"
        >
          SAVE
        </Button>
      </Box>
    </>
  )

  return (
    <>
      {
        taskId ? (
          <CustomTaskDialog
            open={open}
            title={"Interest Allocation"}
            maxWidth="xl"
            handleClose={onClose}
            dialogContent={
              getContent()
            }
            dialogActions={dialogActions}
            taskId={taskId}
          />

        ) : (
          <StandardDialog
            open={open}
            title={"Interest Allocation"}
            maxWidth="xl"
            handleClose={onClose}
            dialogContent={
              getContent()
            }
            dialogActions={dialogActions}
          />

        )
      }
    </>

  );
});